import React, { useEffect, useState } from 'react';
import useSearchProductTypePage from '../hooks/awyes/useSearchProductTypePage';
import SubHeader from './SubHeader';
import SearchFilter from './SearchFilter';
import SearchResults from './SearchResults';

import '../scss/Search.scss';
import { enums } from "../hooks/awyes/useSearchProductPage";

const Search = ({ category, preselect, productType }) => {
  const [filters, setFilters] = useState({});
  const [{ sort, searchBy, orderBy }, setSort] = useState({
    searchBy: enums.searchBy.PROMOTED_UPDATED_DATE_ID,
    orderBy: enums.orderBy.DESCENDING,
  });
  const [productTypes, setProductTypes] = useState([]);
  const [{ data: productTypeData }, { request }] = useSearchProductTypePage();
  const filterKeys = Object.keys(filters ?? {});

  useEffect(() => {
    if (category?.id?.length) {
      request({ filter: { primary: { category: { id: category.id, typeName: category.typeName } } } });
      return () => {
        request.aborted = true;
      };
    }
  }, [category?.id, category?.typeName, request]);

  useEffect(() => {
    if (productTypeData?.items?.length) {
      let found = false;
      const items = productTypeData.items.map((item) => {
        if (productType && item?.awyesId === productType?.awyesId) {
          found = true;
          return productType;
        }
        return item;
      });
      if (productType && !found) {
        items.push(productType);
      }
      setProductTypes(items);
    } else if (productType) {
      setProductTypes([productType]);
    }
  }, [productTypeData?.items, productType]);

  return (
    category?.awyesId?.length ?
      <div className="search">
        { filterKeys.length === 1 ? <SubHeader awyesId={filters[filterKeys[0]].awyesId} title={filterKeys[0]} message={filters[filterKeys[0]].header?.length ? filters[filterKeys[0]].header : `Shop our range of ${filterKeys[0]}`} /> : null }
        { filterKeys.length === 0 && category?.name?.length ? <SubHeader awyesId={category.awyesId} title={category?.name} message={category?.header?.length ? category?.header : `Shop our range of ${category?.name}`} /> : null }
        { filterKeys.length > 1 ? <SubHeader title="Your choice" message="Shop our range filtered to your choices" /> : null }
        <div className="search__content">
          <SearchFilter items={productTypes} preselect={preselect} filters={filters} setFilters={setFilters} />
          <SearchResults categoryId={category.awyesId} preselect={preselect} filters={filters} searchBy={searchBy} orderBy={orderBy} sort={sort} setSort={setSort} />
        </div>
      </div>
    : null
  );
};

export default Search;